export default __webpack_public_path__ + "static/media/githubDark.4b3e063e.svg";